import { render, staticRenderFns } from "./professionalRecommendation.vue?vue&type=template&id=0f5b41ed&scoped=true"
import script from "./professionalRecommendation.vue?vue&type=script&lang=js"
export * from "./professionalRecommendation.vue?vue&type=script&lang=js"
import style0 from "./professionalRecommendation.vue?vue&type=style&index=0&id=0f5b41ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5b41ed",
  null
  
)

export default component.exports